import React from 'react';
import { BookOpen } from 'lucide-react';
import CivicModal from './CivicModal';

interface AboutCivicbeatModalProps {
  isOpen: boolean;
  onClose: () => void;
}

export default function AboutCivicbeatModal({
  isOpen,
  onClose,
}: AboutCivicbeatModalProps) {
  return (
    <CivicModal
      isOpen={isOpen}
      onClose={onClose}
      title="About civicbeat"
      icon={BookOpen}
      maxWidth="md"
    >
      <div
        className="bg-[#1A1A1A] rounded-xl border"
        style={{
          borderColor: 'rgba(255, 255, 255, 0.08)',
          padding: '32px 24px',
        }}
      >
        <div className="space-y-4">
          <p
            className="text-[#E0E0E0]"
            style={{
              fontSize: '14px',
              lineHeight: '1.65',
            }}
          >
            civicbeat explores how music shapes the way we understand power, culture, and civic life.
          </p>

          <p
            className="text-[#E0E0E0]"
            style={{
              fontSize: '14px',
              lineHeight: '1.65',
            }}
          >
            It's built on the idea that civic engagement doesn't have to feel overwhelming or instructional. For generations, music has been where people make sense of injustice, imagine alternatives, and stay connected to the world around them.
          </p>

          <p
            className="text-[#E0E0E0]"
            style={{
              fontSize: '14px',
              lineHeight: '1.65',
            }}
          >
            civicbeat isn't a streaming service or a campaign platform. It's a space for reflection — where songs become entry points to context, history, and meaning, offered in small moments that respect your time and attention.
          </p>

          <p
            className="text-[#E0E0E0]"
            style={{
              fontSize: '14px',
              lineHeight: '1.65',
            }}
          >
            civicbeat is still evolving — shaped over time with artists, communities, and the people who use it.
          </p>
        </div>

        <p
          className="mt-8 text-center"
          style={{
            fontSize: '12px',
            lineHeight: '1.5',
            color: '#606060',
            fontWeight: 400,
          }}
        >
          Made with care for a generation that deserves better civic tools.
        </p>
      </div>
    </CivicModal>
  );
}
